import { render } from "./News09.vue?vue&type=template&id=2432e56a&scoped=true"
import script from "./News09.vue?vue&type=script&lang=js"
export * from "./News09.vue?vue&type=script&lang=js"

import "./News09.vue?vue&type=style&index=0&id=2432e56a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2432e56a"]])

export default __exports__